import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'

export const StudyGuideBox = styled.div`
  display: flex;
  justify-content: space-between;

  ${theme.breakpoints.down('md')} {
    flex-flow: column;
  }
`

export const NavBox = styled.div`
  min-width: 250px;
  position: relative;

  @media only screen and (max-width: 1015px) {
    min-width: 200px;
  }

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const ContentBox = styled.div`
  width: 100%;
  min-height: calc(100vh - 96px);
`

export const ContentFlexBox = styled.div`
  display: flex;
  justify-content: space-between;

  ${theme.breakpoints.down('md')} {
    flex-flow: column;
  }
`

export const RightBox = styled.div``

export const RightBoxContent = styled.div`
  position: sticky;
  top: 96px;
  overflow: hidden;

  ${theme.breakpoints.down('md')} {
    position: static;
  }
`

export const RightBoxOverflow = styled.div`
  min-width: 320px;
  max-width: 320px;

  height: calc(100vh - 160px);

  &.top {
    height: calc(100vh - 225px);
  }

  overflow: auto;

  display: flex;
  flex-flow: column;
  gap: 8px;
  padding: 32px 40px 32px 0;

  @media only screen and (max-width: 1130px) {
    min-width: 270px;
    max-width: 270px;
  }

  @media only screen and (max-width: 1080px) {
    min-width: 250px;
    max-width: 250px;
    padding: 32px 20px 0 0;
  }

  &::-webkit-scrollbar {
    background: #ffffff;
    width: 8px;
    border: 0;
  }

  &::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 100px;
    background: #d8d8d8;
    -webkit-box-shadow: none;

    &:hover {
      background: #d8d8d8;
    }
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
  }

  ${theme.breakpoints.down('md')} {
    min-width: 100%;
    max-width: 100%;
    padding: 20px 0 0;
    box-sizing: border-box;
    position: static;
  }
`

export const CentralBox = styled.div`
  width: 100%;
  position: relative;
  padding: 32px 32px 64px;
  box-sizing: border-box;

  ${theme.breakpoints.down('md')} {
    padding: 16px 20px 64px;
  }

  ${theme.breakpoints.down('sm')} {
    padding: 16px 16px 64px;
  }
`

export const DescriptionBox = styled.div<{$isBorderHidden?: boolean}>`
  ${({$isBorderHidden}) =>
    $isBorderHidden
      ? `padding-bottom: 48px;`
      : `border: 1px solid #EBEFFC; padding: 32px; border-radius: 2px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.10);`}
  width: 100%;
  box-sizing: border-box;

  ${theme.breakpoints.down('md')} {
    ${({$isBorderHidden}) =>
      $isBorderHidden
        ? `padding-bottom: 48px;`
        : `border: 1px solid #EBEFFC; padding: 16px; border-radius: 2px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.10);`}
  }
`

export const StyledLogo = styled.img`
  height: 34px;
`

export const StyledIcon = styled.img`
  width: 32px !important;
  height: 32px !important;
  margin-left: 0 !important;
`

export const SubTitle = styled.h2`
  font-family: Public Sans;
  font-size: 32px;
  margin: 0;
  padding: 0;
  font-weight: 400;

  display: flex;
  align-items: center;
  gap: 8px;

  && img {
    height: 34px;
    vertical-align: bottom;
    margin-left: 16px;
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 20px;

    && img {
      height: 28px;
    }
  }
`

export const Description = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: ${colors.bksGray80};
  line-height: 24px;
  padding-top: 24px;

  && p {
    margin: 0;
    padding: 0;
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

export const TimeBox = styled.p<{$isComplete?: boolean}>`
  ${({$isComplete}) =>
    $isComplete ? `color:${colors.bksGray50};` : `color:${colors.bksGray80};`}
  margin:0;
  padding: 0;
  font-size: 14px;
  padding-top: 16px;
  font-weight: 400;

  && img {
    vertical-align: bottom;
    margin-right: 8px;
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 12px;
  }
`
export const DaysBox = styled.div`
  border: 1px solid #ebeffc;
  background: #ffffff;
  border-radius: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin-top: 32px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  ${theme.breakpoints.down('sm')} {
    margin-top: 20px;
  }
`

export const DayRow = styled.div<{
  $isBreakDay?: boolean
  $isExamDay?: boolean
  $isLastRow?: boolean
}>`
  position: relative;
  padding: 32px;

  ${({$isBreakDay, $isExamDay}) =>
    $isBreakDay
      ? `background-color: rgba(253, 183, 28, 0.10);`
      : $isExamDay
      ? `background-color:#E7F1FA;`
      : null}

  ${({$isLastRow}) => ($isLastRow ? `` : `border-bottom:2px solid #ebeffc;`)}
  
  ${theme.breakpoints.down('sm')} {
    padding: 16px;
  }
`

export const DayTitle = styled.div<{$isComplete?: boolean}>`
  ${({$isComplete}) =>
    $isComplete ? `color:${colors.bksGray50};` : `color:${colors.bksGray80};`}
  font-size: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  cursor: pointer;

  ${theme.breakpoints.down('sm')} {
    font-size: 20px;
  }
`

export const FloatingIcon = styled.img`
  position: absolute;
  left: -24px;

  ${theme.breakpoints.down('sm')} {
    left: -13px;
    width: 12px;
  }
`

export const DayTitleFlexBoxColumn = styled.span`
  display: flex;
  flex-flow: column;
  gap: 8px;
`

export const DayTitleFlexBoxWrap = styled.span`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;

  span {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      width: 24px;
      height: 24px;
    }
  }
`

export const DayContentFlexBox = styled.div<{$isComplete?: boolean}>`
  display: flex;
  gap: 16px;

  span {
    display: flex;
    gap: 8px;
    align-items: center;
    ${({$isComplete}) =>
      $isComplete
        ? `color:${colors.bksGray50} !important;`
        : `color:${colors.bksGray40} !important;`}
    font-size: 14px !important;

    img {
      width: 16px;
      height: 16px;
    }
  }
`

export const CollapseIcon = styled.span`
  margin-left: auto;
`

export const InProgress = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.white};
  padding: 0 8px;
  height: 20px;
  background: #008900;
  border-radius: 2px;
  align-items: center;
  display: flex;

  ${theme.breakpoints.down('sm')} {
    font-size: 12px;
    height: 16px;
  }
`

export const DayText = styled.p<{$isBold?: boolean; $isComplete?: boolean}>`
  margin: 0;
  padding: 0;
  ${({$isBold}) => ($isBold ? `font-weight: 700;` : `font-weight: 400;`)}
  ${({$isComplete}) =>
    $isComplete ? `color:${colors.bksGray50};` : `color:${colors.bksGray80};`}

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

export const DayInnerDivider = styled.div`
  border-bottom: 2px dashed #ebeffc;
  width: 100%;
  margin: 32px 0;
`

export const DayContent = styled.div<{height?: number; $isExpanded?: boolean}>`
  overflow: hidden;
  transition:
    height 0.3s ease-in-out,
    margin 0.3s ease-in-out;
  ${({$isExpanded, height}) =>
    $isExpanded ? `height: ${height}px; margin-top: 24px;` : `height: 0px;`}
`

export const DayItems = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
  margin-top: 16px;
`

export const DayItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: #e8f3fd;
  }

  ${theme.breakpoints.down('md')} {
    justify-content: space-between;
  }
`

export const DayBullet = styled.span`
  color: ${colors.blue1};
  font-size: 24px;
`

export const DayItemTitle = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  && img {
    height: 24px;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const DayItemContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  ${theme.breakpoints.down('md')} {
    min-width: 80px;

    && p {
      margin-left: auto;
    }
  }
`

export const Download = styled.span`
  color: #1377d4;
  font-size: 16px;
`

export const Indicator = styled.div`
  position: absolute;
  width: 100%;
  background: ${colors.crimsonRed};
  height: 2px;
  left: 0;
  bottom: 0;
`

export const IndicatorBall = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${colors.crimsonRed};
  position: absolute;
  left: -5px;
  top: -5px;
`
